import {inject, Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest,} from '@angular/common/http';
import {Observable} from 'rxjs';
import {loadUserLLMModelSettingJSONString} from '../models/llm-setting';
import {DeviceIdService} from '../services/device-id.service';

@Injectable()
export class HttpHeaderInterceptor implements HttpInterceptor {
  private deviceIdService: DeviceIdService = inject(DeviceIdService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const stored = loadUserLLMModelSettingJSONString();
    let modifiedReq;
    const user = this.deviceIdService.getDeviceId() || 'unknown';
    if (stored) {
      const base64: string = btoa(stored);
      modifiedReq = req.clone({
        setHeaders: {
          'X-User-LLM-Model': base64,
          'X-User-ID': user,
        },
      });
    } else {
      modifiedReq = req.clone({
        setHeaders: {
          'X-User-ID': user,
        },
      });
    }

    return next.handle(modifiedReq);
  }
}

export function getHeadersEventSource(deviceId: string) {
  const stored = loadUserLLMModelSettingJSONString();
  const headers: HttpHeaders = new HttpHeaders();
  headers.append('X-User-ID', deviceId);
  if (stored) {
    headers.append('X-User-LLM-Model', btoa(stored));
  }
  return headers;
}
